import React from 'react';
import { Stack, Switch, Typography } from '@mui/material';

/**
 * A permission as a switch, changed straight from the cell (onChange(checked)). A value from
 * the file that isn't Yes / No shows as written beside it until it's switched.
 */
export const FlagCell = ({ value, onChange }) => (
	<Stack direction='row' sx={{ alignItems: 'center' }}>
		<Switch
			size='small'
			checked={value === true}
			onChange={(event) => onChange(event.target.checked)}
			// The switch changes the row; a click on it doesn't select the cell
			onClick={(event) => event.stopPropagation()}
		/>
		{typeof value !== 'boolean' && <Typography variant='body2'>{value}</Typography>}
	</Stack>
);
